import type { Theme } from '@mui/material/styles'

const MuiInputAdornment = (baseTheme: Theme) => ({
  defaultProps: {
    position: 'start',
  },
  styleOverrides: {
    root: {
      fontSize: baseTheme.spacing(1.25),
      color: 'currentColor',

      // NOTE: Increase specificity for better placing the icon
      '&.MuiInputAdornment-filled.MuiInputAdornment-sizeMedium:not(.MuiInputAdornment-hiddenLabel)':
        {
          marginTop: 0,
        },
    },
    positionEnd: {
      '& .MuiButtonBase-root': {
        color: baseTheme.palette.neutral.main,
      },
    },
  },
})

export default MuiInputAdornment
